import dateRenderer from './date'

const createdAtRenderer = dateRenderer('updatedAt')

export default createdAtRenderer
